import React, { useState, useEffect } from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const CompanyTabs = (name) => {
    const [activeTab, setActiveTab] = useState('business');
    const [tabContent, setTabContent] = useState({});
    const [loading, setLoading] = useState(true);
    const [expanded, setExpanded] = useState({});

    const apiUrl = "https://linklogic-backend.vercel.app/api/data?type=company&name=" + name['name'];





    useEffect(() => {
        const fetchData = async () => {
            try {

                const response = await fetch(apiUrl);
                if (!response.ok) throw new Error("Network response was not ok");
                const data = await response.json();
                setTabContent(data);

            } catch (error) {
                console.error("Fetch error:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [apiUrl]); // Runs when apiUrl changes

    const pieChartData = (labels, percentages) => {
        const colors = [
            "#4f899d", "#E9ECEF", "#FF6384", "#36A2EB", "#FFCE56",
            "#6A0572", "#28A745", "#F39C12", "#8E44AD", "#C0392B",
            "#3498DB", "#2ECC71", "#1ABC9C", "#D35400", "#BDC3C7"
        ];

        const hoverColors = [
            "#4f999d", "#d3d7dc", "#FF7394", "#47B3FC", "#FFD766",
            "#7B068B", "#30B757", "#F4B942", "#9B59B6", "#E74C3C",
            "#4AA3DF", "#32D178", "#20D0C6", "#E67E22", "#ECF0F1"
        ];

        return {
            labels: labels,
            datasets: [
                {
                    data: percentages,
                    backgroundColor: labels.map((_, index) => colors[index % colors.length]),
                    hoverBackgroundColor: labels.map((_, index) => hoverColors[index % hoverColors.length]),
                },
            ],
        };
    };


    const renderTabDictionaryContent = () => {
        const content = tabContent[activeTab];

        if (typeof content === 'object' && !Array.isArray(content)) {
            return (
                <div style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '10px', paddingBottom: '10px', }}>
                    {Object.entries(content).map(([key, value]) => (
                        <div key={key} style={{ marginBottom: '20px', backgroundColor: 'white', paddingLeft: '10px', paddingRight: '10px', paddingTop: '4px', paddingBottom: '4px', borderRadius: '5px' }}>
                            <h3 style={{
                                fontSize: '18px',
                                fontWeight: '600',
                            }}>
                                {key}
                            </h3>
                            <p style={{ fontSize: '16px', marginTop: '-10px' }}>
                                {value.description}
                            </p>
                        </div>
                    ))}
                </div>
            );
        }

        return null;
    };

    const renderTable = () => {
        const data = tabContent[activeTab];

        return (
            <div style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '20px', paddingBottom: '20px' }}>
                <table
                    border="1"
                    style={{
                        width: '100% ',
                        borderCollapse: 'collapse',

                    }}
                >
                    <thead>
                        <tr
                            style={{
                                backgroundColor: '#f2f2f2',
                                textAlign: 'left',
                                fontWeight: 'bold',
                            }}
                        >
                            <th style={{ padding: '12px 15px' }}>Project</th>
                            <th style={{ padding: '12px 15px' }}>Value</th>
                            <th style={{ padding: '12px 15px' }}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.keys(data).map((key, index) => (
                            <tr
                                key={key}
                                style={{
                                    backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s',
                                }}
                                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#f1f1f1')}
                                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#fafafa' : '#fff')}
                            >
                                <td style={{ padding: '12px 15px' }}>{key}</td>
                                <td style={{ padding: '12px 15px' }}>  {data[key].value === 'Not mentioned' ? '-' : data[key].value}
                                </td>
                                <td style={{ padding: '12px 15px' }}>{data[key].status}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );

    };

    const renderPieChart = (item) => {
        console.log(item);
        const labels = Object.keys(item);
        const values = Object.values(item).map((value) => value.percentage);

        return (
            <div style={{ width: '250px', height: '250px', }}>
                <Pie data={pieChartData(labels, values)} />
            </div>
        )
    };

    const renderRevenueTable = (data) => {

        return (
            <table
                border="1"
                style={{
                    width: '75%',
                    borderCollapse: 'collapse',
                    marginTop: '20px',
                }}
            >
                <thead>
                    <tr
                        style={{
                            backgroundColor: '#f2f2f2',
                            textAlign: 'left',
                            fontWeight: 'bold',
                        }}
                    >
                        <th style={{ padding: '12px 15px' }}>Product</th>
                        <th style={{ padding: '12px 15px' }}>Value</th>
                        <th style={{ padding: '12px 15px' }}>Percentage</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(data).map((key, index) => (
                        <tr
                            key={key}
                            style={{
                                backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s',
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#f1f1f1')}
                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#fafafa' : '#fff')}
                        >
                            <td style={{ padding: '12px 15px' }}>{key}</td>
                            <td style={{ padding: '12px 15px' }}>  {data[key].value === 'Not mentioned' ? '-' : data[key].value}
                            </td>
                            <td style={{ padding: '12px 15px' }}>{data[key].percentage === 'Not mentioned' ? '-' : data[key].percentage}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );

    };

    const isAnyPercentageNotMentioned = (sectionData) => {
        return Object.values(sectionData).some(item => item.percentage === 'Not mentioned');
    };

    // Render Product or Geography sections
    const renderSection = () => {
        const sectionData = tabContent[activeTab];
        return Object.keys(sectionData).map((key) => {
            const item = sectionData[key];
            const isTableRequired = isAnyPercentageNotMentioned(item);

            return (
                <div key={key} style={{ marginBottom: '20px', padding: '20px', alignContent: 'center', alignItems: 'center' }}>
                    <h3>{key === 'product' ? 'Product' : 'Geography'}</h3>
                    {isTableRequired ? renderRevenueTable(item) : renderPieChart(item)}
                </div>
            );
        });
    };

    const toggleExpand = (item) => {
        setExpanded((prev) => ({
            ...prev,
            [item]: !prev[item], // Toggle expansion
        }));
    };
    const renderList = () => {
        const data = tabContent[activeTab]
        return (
            <div
                style={{
                    padding: '20px',
                    backgroundColor: '#f9f9f9', // Light background color
                    borderRadius: '10px', // Rounded corners
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)', // 3 equal columns
                    gap: '20px',
                }}
            >
                {data.map((item, index) => {
                    if (typeof item === 'string') {
                        // If the item is a string, display it as a list item in a column
                        return (
                            <div
                                key={index}
                                style={{
                                    backgroundColor: '#ffffff', // Light background for each item
                                    padding: '10px',
                                    marginBottom: '8px',
                                    borderRadius: '8px', // Rounded corners for list items
                                }}
                            >
                                {item}
                            </div>
                        );
                    } else if (typeof item === 'object') {
                        // If the item is an object, display the key and toggle its expansion
                        const [key, list] = Object.entries(item)[0];
                        return (
                            <div key={key}>
                                <div
                                    onClick={() => toggleExpand(key)}
                                    style={{
                                        cursor: 'pointer',
                                        color: '#333', // Dark text for readability
                                        padding: '10px',
                                        backgroundColor: '#ffffff',
                                        borderRadius: '8px',
                                        marginBottom: '8px',
                                        display: 'flex',
                                        justifyContent: 'space-between', // Flex for aligning the arrow
                                        alignItems: 'center',
                                    }}
                                >
                                    {key} <span>{expanded[key] ? '▲' : '▼'}</span>
                                </div>
                                {expanded[key] && (
                                    <ul
                                        style={{
                                            listStyleType: 'none',
                                            paddingLeft: '20px',
                                            margin: 0,
                                            display: 'flex',
                                            flexDirection: 'column',
                                        }}
                                    >
                                        {list.map((subItem, subIndex) => (
                                            <li
                                                key={subIndex}
                                                style={{
                                                    backgroundColor: '#ffffff',
                                                    padding: '8px 12px',
                                                    marginBottom: '6px',
                                                    borderRadius: '8px',
                                                }}
                                            >
                                                {subItem}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        );
                    }
                    return null; // In case of invalid data
                })}
            </div>
        );

    };

    const renderOverview = () => {
        const data = tabContent[activeTab];
        const overviewData = data;
        return (
            <div style={{ padding: '20px' }}>
                {/* Render Sectors */}
                <h3 style={{ marginTop: '-20px' }}>Sectors</h3>
                <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                    {Object.entries(overviewData.Sectors).map(([key, value]) => (
                        <div
                            key={key}
                            style={{
                                flex: 1,
                                minWidth: "200px",
                                color: "#333",
                                backgroundColor: "white",
                                borderRadius: "8px",
                                padding: "10px",
                                textAlign: "center", // Centers text
                            }}
                        >
                            <h3 style={{ fontWeight: "bold", marginBottom: "5px" }}>{key}</h3>
                            <ul style={{ listStyleType: "none", paddingLeft: "0" }}> {/* Removes bullets and left padding */}
                                {Array.isArray(value) ? value.map((item, index) => <li key={index}>{item}</li>) : <li>{value}</li>}
                            </ul>
                        </div>
                    ))}
                </div>



                {/* Render Highlights */}
                <h3>Highlights</h3>
                <div style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '10px', paddingBottom: '10px', }}>
                    {Object.entries(overviewData.Highlights).map(([key, value]) => (
                        <div key={key} style={{ marginBottom: '20px', backgroundColor: 'white', paddingLeft: '10px', paddingRight: '10px', paddingTop: '4px', paddingBottom: '4px', borderRadius: '5px' }}>
                            <h3 style={{
                                fontSize: '18px',
                                fontWeight: '600',
                            }}>
                                {key}
                            </h3>
                            <p style={{ fontSize: '16px', marginTop: '-10px' }}>
                                {value}
                            </p>
                        </div>
                    ))}
                </div>

                {/* Render Subsidiaries */}
                <h3>Subsidiaries</h3>
                <div
                    style={{
                        padding: '20px',
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)', // 3 equal columns
                        gap: '20px',
                        marginTop: '-20px',
                    }}
                >
                    {overviewData.Subsidiaries.map((item, index) => {
                        if (typeof item === 'string') {
                            // If the item is a string, display it as a list item in a column
                            return (
                                <div
                                    key={index}
                                    style={{
                                        backgroundColor: '#ffffff', // Light background for each item
                                        padding: '10px',
                                        marginBottom: '8px',
                                        borderRadius: '8px', // Rounded corners for list items
                                    }}
                                >
                                    {item}
                                </div>
                            );
                        }
                        return null; // In case of invalid data
                    })}
                </div>
            </div>
        );
    };

    const renderExpandableRiskList = () => {
        const data = tabContent[activeTab];

        return (
            <div
                style={{
                    paddingLeft: "20px",
                    paddingRight: "20px",
                    paddingTop: "0px",

                }}
            >
                <ul style={{ listStyleType: "none", padding: 0 }}>
                    {data.map((item, index) => {
                        if (typeof item === "string") {
                            return (
                                <li
                                    key={index}
                                    style={{
                                        backgroundColor: "#ffffff",
                                        padding: "12px",
                                        marginBottom: "16px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    {item}
                                </li>
                            );
                        } else if (typeof item === "object") {
                            const [key, list] = Object.entries(item)[0];
                            return (
                                <li key={key} style={{ marginBottom: "8px" }}>
                                    <div
                                        onClick={() => toggleExpand(key)}
                                        style={{
                                            cursor: "pointer",
                                            backgroundColor: "#ffffff",
                                            padding: "12px",
                                            borderRadius: "5px",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            marginBottom: expanded[key] ? "0px" : "16px",
                                        }}
                                    >
                                        {key} <span>{expanded[key] ? "▲" : "▼"}</span>
                                    </div>
                                    {expanded[key] && (
                                        <ul style={{ paddingLeft: "20px", margin: "4px 0 0 0" }}>
                                            {list.map((subItem, subIndex) => (
                                                <li
                                                    key={subIndex}
                                                    style={{
                                                        backgroundColor: "#ffffff",
                                                        padding: "10px",
                                                        marginBottom: "4px",
                                                        borderRadius: "5px",
                                                    }}
                                                >
                                                    {subItem}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </li>
                            );
                        }
                        return null;
                    })}
                </ul>
            </div>
        );
    };

    const tabOrder = [
        "Overview",
        "Product Expertise",
        "Revenue Breakdown",
        "Work Order",
        "Capex",
        "New Products",
        "Emerging Opportunities",
        "Policy/Sectoral boost",
        "Risks",
        "Partnerships",
    ];

    const styles = {
        container: {
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '20px',
            fontFamily: 'Arial, sans-serif'
        },
        header: {
            textAlign: 'left',
            marginBottom: '30px',
            color: '#333'
        },
        companyName: {
            fontSize: '2.5em',
            marginBottom: '20px',
            color: '#2c3e50'
        },
        sectorsContainer: {
            marginBottom: '30px',
            padding: '20px',
            backgroundColor: '#f8f9fa',
            borderRadius: '8px'
        },
        sectorGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
            gap: '20px',
            marginTop: '15px'
        },
        sectorCard: {
            backgroundColor: 'white',
            padding: '15px',
            borderRadius: '6px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
        },
        sectorTitle: {
            color: '#2c3e50',
            fontSize: '1.2em',
            marginBottom: '10px',
            fontWeight: 'bold'
        },
        segmentList: {
            margin: '0',
            padding: '0 0 0 20px'
        },
        segmentItem: {
            color: '#666',
            margin: '5px 0'
        },
        tabsContainer: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '10px',
            marginBottom: '20px'
        },
        tab: {
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            backgroundColor: '#f0f0f0',
            transition: 'background-color 0.3s'
        },
        activeTab: {
            backgroundColor: '#4f899d',
            color: 'white'
        },
        contentContainer: {
            backgroundColor: '#f9f9f9',
            padding: '0px',
            borderRadius: '0px 5px',
            borderBottom: 'none',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            overflowY: 'scroll', // Enables vertical scrolling
            maxHeight: '450px',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
        },

        title: {
            marginTop: '0',
            marginBottom: '15px',
            color: '#333'
        },
        content: {
            lineHeight: '1.6',
            color: '#666'
        }
    };
    if (loading) {
        return <div>Loading...</div>;
    }
    return (
        <div style={styles.container}>
            <header style={styles.header}>
                <h1 style={styles.companyName}>{name['name']}</h1>


            </header>
            <div style={styles.tabsContainer}>
                {tabOrder
                    .filter((key) => Object.keys(tabContent || {}).includes(key))
                    .map((key) => (
                        <button
                            key={key}
                            style={{
                                ...styles.tab,
                                ...(activeTab === key ? styles.activeTab : {}),
                            }}
                            onClick={() => setActiveTab(key)}
                        >
                            {key}
                        </button>
                    ))}
            </div>
            <div style={styles.contentContainer}>
                {(activeTab === 'Partnerships' || activeTab === 'Emerging Opportunities' || activeTab === 'New Products' || activeTab === 'Capex') && renderTabDictionaryContent()}
            </div>

            <div style={styles.contentContainer}>
                {(activeTab === 'Work Order') && renderTable()}
            </div>

            <div style={styles.contentContainer}>

                <div style={{ display: 'flex', justifyContent: '', padding: '20px' }}>

                    {(activeTab === 'Revenue Breakdown') && renderSection()}
                </div>
            </div>

            <div style={styles.contentContainer}>
                {(activeTab === 'Product Expertise') && renderList()}
            </div>

            <div style={styles.contentContainer}>
                {(activeTab === 'Risks') && renderExpandableRiskList()}
            </div>

            <div style={styles.contentContainer}>
                {(activeTab === 'Overview') && renderOverview()}
            </div>;


        </div>
    );
};

export default CompanyTabs;